<template>
  <header>
    <img
      src="../assets/img/logo.svg"
      alt="Archimatika Logo"
      title="Archimatika Logo"
      id="logo"
      @click="showMenu = false"
    />
    <a
      v-for="link in links"
      :key="link.id"
      :href="lang === 0 ? link.href : link.hrefRu"
      :id="link.idClass"
      :target="link.href !== '#' ? '_blank' : ''"
      @click="link.id === 1 ? $gtag.event('contact_link') : ''"
    >
      <div class="circle"></div>
      <span class="link-span">{{
        lang === 0 ? link.name : link.nameRu
      }}</span></a
    >
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      @click="showMenu = !showMenu"
      :class="[{ active: showMenu }, 'burger']"
    >
      <g>
        <rect x="10" y="19" width="20" height="2" fill="#FFFEFF" />
      </g>
      <g>
        <rect x="10" y="24" width="20" height="2" fill="#FFFEFF" />
      </g>
      <g>
        <rect x="10" y="14" width="20" height="2" fill="#FFFEFF" />
      </g>
    </svg>
  </header>
  <div :class="[{ ru: lang === 1 }, 'top-row']">
    <div class="overlay"></div>
    <div class="title">
      <h1 v-html="divideText(text.first.h1, 99, 9)" id="h1" v-if="lang === 0" />
      <h1
        v-html="divideTextNormal(text.first.ru.h1, false)"
        id="h1"
        v-else
        class="h1-ru"
      />
      <h2
        v-html="divideText(text.first.h2, 24, 14)"
        id="h2"
        v-show="lang === 0"
      ></h2>
    </div>
    <div class="arrow-top">
      <svg
        width="60"
        height="200"
        viewBox="0 0 60 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        v-if="lang === 0"
      >
        <g class="main-svg">
          <rect
            width="60"
            height="196"
            rx="30"
            y="2"
            fill="#FFFEFF"
            stroke-width="2"
            stroke="#FFFEFF"
          />
        </g>
        <g class="text">
          <path
            d="M31.8604 115.191L31.7197 113.583C32.3643 113.507 32.8945 113.331 33.3105 113.056C33.7207 112.774 34.0547 112.341 34.3125 111.755C34.5645 111.169 34.6904 110.51 34.6904 109.777C34.6904 109.127 34.5937 108.553 34.4004 108.055C34.207 107.557 33.9434 107.187 33.6094 106.947C33.2695 106.701 32.9004 106.578 32.502 106.578C32.0977 106.578 31.7461 106.695 31.4473 106.93C31.1426 107.164 30.8877 107.551 30.6826 108.09C30.5479 108.436 30.3398 109.2 30.0586 110.384C29.7715 111.567 29.502 112.396 29.25 112.871C28.9277 113.486 28.5293 113.946 28.0547 114.251C27.5742 114.55 27.0381 114.699 26.4463 114.699C25.7959 114.699 25.1895 114.515 24.627 114.146C24.0586 113.776 23.6279 113.237 23.335 112.528C23.042 111.819 22.8955 111.031 22.8955 110.164C22.8955 109.209 23.0508 108.368 23.3613 107.642C23.666 106.909 24.1172 106.347 24.7148 105.954C25.3125 105.562 25.9893 105.351 26.7451 105.321L26.8682 106.956C26.0537 107.044 25.4385 107.343 25.0225 107.853C24.6064 108.356 24.3984 109.104 24.3984 110.094C24.3984 111.125 24.5889 111.878 24.9697 112.353C25.3447 112.821 25.7988 113.056 26.332 113.056C26.7949 113.056 27.1758 112.889 27.4746 112.555C27.7734 112.227 28.0811 111.371 28.3975 109.988C28.708 108.6 28.9805 107.647 29.2148 107.132C29.5605 106.382 30 105.828 30.5332 105.471C31.0605 105.113 31.6699 104.935 32.3613 104.935C33.0469 104.935 33.6943 105.131 34.3037 105.523C34.9072 105.916 35.3789 106.481 35.7187 107.22C36.0527 107.952 36.2197 108.778 36.2197 109.698C36.2197 110.864 36.0498 111.843 35.71 112.634C35.3701 113.419 34.8604 114.037 34.1807 114.488C33.4951 114.934 32.7217 115.168 31.8604 115.191ZM32.5811 96.7168L32.7832 95.1611C33.8555 95.3311 34.6963 95.7676 35.3057 96.4707C35.9092 97.168 36.2109 98.0264 36.2109 99.0459C36.2109 100.323 35.7949 101.352 34.9629 102.131C34.125 102.904 32.9268 103.291 31.3682 103.291C30.3604 103.291 29.4785 103.124 28.7227 102.79C27.9668 102.456 27.4014 101.949 27.0264 101.27C26.6455 100.584 26.4551 99.8398 26.4551 99.0371C26.4551 98.0234 26.7129 97.1943 27.2285 96.5498C27.7383 95.9053 28.4648 95.4922 29.4082 95.3105L29.6455 96.8486C29.0186 96.9951 28.5469 97.2559 28.2305 97.6309C27.9141 98 27.7559 98.4482 27.7559 98.9756C27.7559 99.7725 28.043 100.42 28.6172 100.918C29.1855 101.416 30.0879 101.665 31.3242 101.665C32.5781 101.665 33.4893 101.425 34.0576 100.944C34.626 100.464 34.9102 99.8369 34.9102 99.0635C34.9102 98.4424 34.7197 97.9238 34.3389 97.5078C33.958 97.0918 33.3721 96.8281 32.5811 96.7168ZM36 93.8252L26.666 93.8252L26.666 92.4014L28.0811 92.4014C27.4189 92.0381 26.9824 91.7041 26.7715 91.3994C26.5605 91.0889 26.4551 90.749 26.4551 90.3799C26.4551 89.8467 26.625 89.3047 26.9648 88.7539L28.4326 89.2988C28.2041 89.6855 28.0898 90.0723 28.0898 90.459C28.0898 90.8047 28.1953 91.1152 28.4062 91.3906C28.6113 91.666 28.8984 91.8623 29.2676 91.9795C29.8301 92.1553 30.4453 92.2432 31.1133 92.2432L36 92.2432L36 93.8252ZM31.333 88.4023C29.6045 88.4023 28.3242 87.9219 27.4922 86.9609C26.8008 86.1582 26.4551 85.1797 26.4551 84.0254C26.4551 82.7422 26.877 81.6934 27.7207 80.8789C28.5586 80.0645 29.7187 79.6572 31.2012 79.6572C32.4023 79.6572 33.3486 79.8389 34.04 80.2021C34.7256 80.5596 35.2588 81.084 35.6396 81.7754C36.0205 82.4609 36.2109 83.2109 36.2109 84.0254C36.2109 85.332 35.792 86.3896 34.9541 87.1982C34.1162 88.001 32.9092 88.4023 31.333 88.4023ZM31.333 86.7764C32.5283 86.7764 33.4248 86.5156 34.0225 85.9941C34.6143 85.4727 34.9102 84.8164 34.9102 84.0254C34.9102 83.2402 34.6113 82.5869 34.0137 82.0654C33.416 81.5439 32.5049 81.2832 31.2803 81.2832C30.126 81.2832 29.2529 81.5469 28.6611 82.0742C28.0635 82.5957 27.7646 83.2461 27.7646 84.0254C27.7646 84.8164 28.0605 85.4727 28.6523 85.9941C29.2441 86.5156 30.1377 86.7764 31.333 86.7764ZM36 77.8291L23.1152 77.8291L23.1152 76.2471L36 76.2471L36 77.8291ZM36 73.8213L23.1152 73.8213L23.1152 72.2393L36 72.2393L36 73.8213ZM36 58.7129L34.8223 58.7129C35.748 59.3047 36.2109 60.1748 36.2109 61.3232C36.2109 62.0674 36.0059 62.7529 35.5957 63.3799C35.1855 64.001 34.6143 64.4844 33.8818 64.8301C33.1436 65.1699 32.2969 65.3398 31.3418 65.3398C30.4102 65.3398 29.5664 65.1846 28.8105 64.874C28.0488 64.5635 27.4658 64.0977 27.0615 63.4766C26.6572 62.8555 26.4551 62.1611 26.4551 61.3936C26.4551 60.8311 26.5752 60.3301 26.8154 59.8906C27.0498 59.4512 27.3574 59.0937 27.7383 58.8184L23.1152 58.8184L23.1152 57.2451L36 57.2451L36 58.7129ZM31.3418 63.7139C32.5371 63.7139 33.4307 63.4619 34.0225 62.958C34.6143 62.4541 34.9102 61.8594 34.9102 61.1738C34.9102 60.4824 34.6289 59.8965 34.0664 59.416C33.498 58.9297 32.6338 58.6865 31.4736 58.6865C30.1963 58.6865 29.2588 58.9326 28.6611 59.4248C28.0635 59.917 27.7646 60.5234 27.7646 61.2441C27.7646 61.9473 28.0518 62.5361 28.626 63.0107C29.2002 63.4795 30.1055 63.7139 31.3418 63.7139ZM31.333 55.3379C29.6045 55.3379 28.3242 54.8574 27.4922 53.8965C26.8008 53.0937 26.4551 52.1152 26.4551 50.9609C26.4551 49.6777 26.877 48.6289 27.7207 47.8145C28.5586 47 29.7187 46.5928 31.2012 46.5928C32.4023 46.5928 33.3486 46.7744 34.04 47.1377C34.7256 47.4951 35.2588 48.0195 35.6396 48.7109C36.0205 49.3965 36.2109 50.1465 36.2109 50.9609C36.2109 52.2676 35.792 53.3252 34.9541 54.1338C34.1162 54.9365 32.9092 55.3379 31.333 55.3379ZM31.333 53.7119C32.5283 53.7119 33.4248 53.4512 34.0225 52.9297C34.6143 52.4082 34.9102 51.752 34.9102 50.9609C34.9102 50.1758 34.6113 49.5225 34.0137 49.001C33.416 48.4795 32.5049 48.2187 31.2803 48.2187C30.126 48.2187 29.2529 48.4824 28.6611 49.0098C28.0635 49.5312 27.7646 50.1816 27.7646 50.9609C27.7646 51.752 28.0605 52.4082 28.6523 52.9297C29.2441 53.4512 30.1377 53.7119 31.333 53.7119ZM36 43.0068L26.666 45.8633L26.666 44.2285L32.0537 42.7432L34.0576 42.1895C33.958 42.166 33.3164 42.0049 32.1328 41.7061L26.666 40.2207L26.666 38.5947L32.0801 37.1973L33.8643 36.7314L32.0625 36.1953L26.666 34.5957L26.666 33.0576L36 35.9756L36 37.6191L30.4102 39.1045L28.8193 39.4648L36 41.3545L36 43.0068ZM36 31.7217L26.666 31.7217L26.666 30.2979L27.9932 30.2979C26.9678 29.6123 26.4551 28.6221 26.4551 27.3271C26.4551 26.7646 26.5576 26.249 26.7627 25.7803C26.9619 25.3057 27.2256 24.9512 27.5537 24.7168C27.8818 24.4824 28.2715 24.3184 28.7227 24.2246C29.0156 24.166 29.5283 24.1367 30.2607 24.1367L36 24.1367L36 25.7187L30.3223 25.7187C29.6777 25.7187 29.1973 25.7803 28.8809 25.9033C28.5586 26.0264 28.3037 26.2461 28.1162 26.5625C27.9228 26.873 27.8262 27.2393 27.8262 27.6611C27.8262 28.335 28.04 28.918 28.4678 29.4102C28.8955 29.8965 29.707 30.1396 30.9023 30.1396L36 30.1396L36 31.7217Z"
            fill="#FFFEFF"
          />
        </g>
        <g>
          <path
            d="M23 172.058V170.596C24.5447 171.353 25.6222 171.923 26.2323 172.308C26.8424 172.692 27.7705 173.372 29.0167 174.346V146H30.9833V174.346C32.3853 173.026 34.3908 171.763 37 170.558V172.038C35.1307 173.692 33.7093 175.115 32.7357 176.308C31.7752 177.5 30.9898 178.731 30.3797 180H29.484C29.0037 178.897 28.2703 177.724 27.2837 176.481C26.3102 175.237 24.8822 173.763 23 172.058Z"
            fill="#FFFEFF"
          />
        </g>
        <g class="rects">
          <rect x="29" y="131" width="2" height="10" fill="#FFFEFF" />
        </g>
        <g class="rects">
          <rect x="29" y="121" width="2" height="5" fill="#FFFEFF" />
        </g>
      </svg>
      <svg
        width="60"
        height="208"
        viewBox="0 0 60 208"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        v-if="lang === 1"
      >
        <g class="main-svg">
          <rect
            width="60"
            height="208"
            rx="30"
            fill="#FFFEFF"
            stroke-width="2"
            stroke="#FFFEFF"
          />
        </g>
        <g class="text">
          <path
            d="M31.4824 113.418L31.9131 111.713C33.3135 112.07 34.3828 112.715 35.1211 113.646C35.8535 114.572 36.2197 115.706 36.2197 117.048C36.2197 118.437 35.9385 119.567 35.376 120.44C34.8076 121.308 33.9873 121.97 32.915 122.427C31.8428 122.878 30.6914 123.104 29.4609 123.104C28.1191 123.104 26.9502 122.849 25.9541 122.339C24.9521 121.823 24.1934 121.094 23.6777 120.15C23.1562 119.201 22.8955 118.158 22.8955 117.021C22.8955 115.732 23.2236 114.648 23.8799 113.77C24.5361 112.891 25.459 112.278 26.6484 111.933L27.0439 113.611C26.1064 113.91 25.4238 114.344 24.9961 114.912C24.5684 115.48 24.3545 116.195 24.3545 117.057C24.3545 118.047 24.5918 118.876 25.0664 119.544C25.541 120.206 26.1797 120.672 26.9824 120.941C27.7793 121.211 28.6025 121.346 29.4521 121.346C30.5479 121.346 31.5059 121.187 32.3262 120.871C33.1406 120.549 33.75 120.051 34.1543 119.377C34.5586 118.703 34.7607 117.974 34.7607 117.188C34.7607 116.233 34.4854 115.425 33.9346 114.763C33.3838 114.101 32.5664 113.652 31.4824 113.418ZM26.666 109.814L26.666 108.232L30.7002 108.232C30.7002 107.729 30.6035 107.377 30.4102 107.178C30.2168 106.973 29.6543 106.674 28.7227 106.281C27.9844 105.971 27.498 105.719 27.2637 105.525C27.0293 105.332 26.8711 105.109 26.7891 104.857C26.707 104.605 26.666 104.201 26.666 103.645L26.666 103.328L27.9756 103.328L27.9668 103.768C27.9668 104.184 28.0283 104.45 28.1514 104.567C28.2803 104.69 28.6641 104.878 29.3027 105.13C29.9121 105.37 30.334 105.59 30.5684 105.789C30.8027 105.988 31.0166 106.296 31.21 106.712C31.3916 106.032 32.0244 105.364 33.1084 104.708L36 102.977L36 104.717L33.1084 106.404C32.5283 106.75 32.1475 107.052 31.9658 107.31C31.7783 107.567 31.6846 107.875 31.6846 108.232L36 108.232L36 109.814L26.666 109.814ZM39.5771 101.931L26.666 101.931L26.666 100.489L27.8789 100.489C27.4043 100.149 27.0498 99.7656 26.8154 99.3379C26.5752 98.9102 26.4551 98.3916 26.4551 97.7822C26.4551 96.9854 26.6602 96.2822 27.0703 95.6729C27.4805 95.0635 28.0605 94.6035 28.8105 94.293C29.5547 93.9824 30.3721 93.8271 31.2627 93.8271C32.2178 93.8271 33.0791 94 33.8467 94.3457C34.6084 94.6855 35.1943 95.1836 35.6045 95.8398C36.0088 96.4902 36.2109 97.1758 36.2109 97.8965C36.2109 98.4238 36.0996 98.8984 35.877 99.3203C35.6543 99.7363 35.373 100.079 35.0332 100.349L39.5771 100.349L39.5771 101.931ZM31.3857 100.498C32.5869 100.498 33.4746 100.255 34.0488 99.7686C34.623 99.2822 34.9102 98.6934 34.9102 98.002C34.9102 97.2988 34.6143 96.6982 34.0225 96.2002C33.4248 95.6963 32.502 95.4443 31.2539 95.4443C30.0645 95.4443 29.1738 95.6904 28.582 96.1826C27.9902 96.6689 27.6943 97.252 27.6943 97.9316C27.6943 98.6055 28.0107 99.2031 28.6436 99.7246C29.2705 100.24 30.1846 100.498 31.3857 100.498ZM31.333 92.5C29.6045 92.5 28.3242 92.0195 27.4922 91.0586C26.8008 90.2559 26.4551 89.2773 26.4551 88.123C26.4551 86.8398 26.877 85.791 27.7207 84.9766C28.5586 84.1621 29.7187 83.7549 31.2012 83.7549C32.4023 83.7549 33.3486 83.9365 34.04 84.2998C34.7256 84.6572 35.2588 85.1816 35.6396 85.873C36.0205 86.5586 36.2109 87.3086 36.2109 88.123C36.2109 89.4297 35.792 90.4873 34.9541 91.2959C34.1162 92.0986 32.9092 92.5 31.333 92.5ZM31.333 90.874C32.5283 90.874 33.4248 90.6133 34.0225 90.0918C34.6143 89.5703 34.9102 88.9141 34.9102 88.123C34.9102 87.3379 34.6113 86.6846 34.0137 86.1631C33.416 85.6416 32.5049 85.3809 31.2803 85.3809C30.126 85.3809 29.2529 85.6445 28.6611 86.1719C28.0635 86.6934 27.7646 87.3437 27.7646 88.123C27.7646 88.9141 28.0605 89.5703 28.6523 90.0918C29.2441 90.6133 30.1377 90.874 31.333 90.874ZM26.666 81.5225L26.666 74.1748L36 74.1748L36 75.748L27.9756 75.748L27.9756 79.9404L32.625 79.9404C33.709 79.9404 34.4238 79.9756 34.7695 80.0459C35.1152 80.1162 35.417 80.3096 35.6748 80.626C35.9326 80.9424 36.0615 81.3994 36.0615 81.9971C36.0615 82.3662 36.0381 82.791 35.9912 83.2715L34.6728 83.2715L34.6728 82.5771C34.6728 82.249 34.6406 82.0146 34.5762 81.874C34.5059 81.7334 34.3975 81.6396 34.251 81.5928C34.1045 81.5459 33.627 81.5225 32.8184 81.5225L26.666 81.5225ZM26.666 71.8105L26.666 70.2285L30.3135 70.2285L30.3135 68.2246C30.3135 66.918 30.5684 65.9131 31.0781 65.21C31.582 64.501 32.2793 64.1465 33.1699 64.1465C33.9492 64.1465 34.6172 64.4424 35.1738 65.0342C35.7246 65.6201 36 66.5605 36 67.8555L36 71.8105L26.666 71.8105ZM34.6992 70.2285L34.6992 68.5674C34.6992 67.5654 34.5762 66.8506 34.3301 66.4229C34.084 65.9951 33.7002 65.7812 33.1787 65.7812C32.7744 65.7812 32.4141 65.9395 32.0977 66.2559C31.7812 66.5723 31.623 67.2725 31.623 68.3564L31.623 70.2285L34.6992 70.2285ZM26.666 57.3789L26.666 53.7314C26.666 52.835 26.7422 52.1699 26.8945 51.7363C27.041 51.2969 27.3135 50.9219 27.7119 50.6113C28.1103 50.2949 28.5879 50.1367 29.1445 50.1367C29.5898 50.1367 29.9795 50.2305 30.3135 50.418C30.6416 50.5996 30.917 50.875 31.1396 51.2441C31.2861 50.8047 31.5615 50.4414 31.9658 50.1543C32.3643 49.8613 32.8389 49.7148 33.3896 49.7148C34.2744 49.7734 34.9307 50.0898 35.3584 50.6641C35.7861 51.2383 36 52.0732 36 53.1689L36 57.3789L26.666 57.3789ZM30.5947 55.7969L30.5947 54.1094C30.5947 53.4355 30.5596 52.9727 30.4893 52.7207C30.4189 52.4687 30.2783 52.2432 30.0674 52.0439C29.8506 51.8447 29.5928 51.7451 29.2939 51.7451C28.8018 51.7451 28.459 51.9209 28.2656 52.2725C28.0723 52.6182 27.9756 53.2129 27.9756 54.0566L27.9756 55.7969L30.5947 55.7969ZM34.6992 55.7969L34.6992 53.7139C34.6992 52.8174 34.5967 52.2021 34.3916 51.8682C34.1807 51.5342 33.8203 51.3584 33.3105 51.3408C33.0117 51.3408 32.7363 51.4375 32.4844 51.6309C32.2266 51.8242 32.0654 52.0762 32.001 52.3867C31.9307 52.6973 31.8955 53.1953 31.8955 53.8809L31.8955 55.7969L34.6992 55.7969ZM26.666 47.8164L26.666 46.2344L30.5508 46.2344L30.5508 41.8486L26.666 41.8486L26.666 40.2666L36 40.2666L36 41.8486L31.8603 41.8486L31.8603 46.2344L36 46.2344L36 47.8164L26.666 47.8164ZM26.666 37.876L26.666 36.2939L33.7852 36.2939L26.666 31.9082L26.666 30.2031L36 30.2031L36 31.7852L28.9248 31.7852L36 36.1709L36 37.876L26.666 37.876ZM31.7812 25.7559L30.542 25.7559C30.5361 25.0879 30.5098 24.6338 30.4629 24.3936C30.416 24.1475 30.2754 23.916 30.041 23.6992C29.8066 23.4824 29.5137 23.374 29.1621 23.374C28.7344 23.374 28.3945 23.5176 28.1426 23.8047C27.8848 24.0859 27.7559 24.4521 27.7559 24.9033C27.7559 25.7939 28.2803 26.418 29.3291 26.7754L29.083 28.2783C27.3311 27.8096 26.4551 26.6787 26.4551 24.8857C26.4551 23.8896 26.7275 23.1104 27.2725 22.5479C27.8174 21.9795 28.4678 21.6953 29.2236 21.6953C29.9853 21.6953 30.5918 22.0645 31.043 22.8027C31.2949 22.334 31.6172 21.9824 32.0098 21.748C32.3965 21.5137 32.8564 21.3965 33.3896 21.3965C34.2275 21.3965 34.9072 21.7012 35.4287 22.3105C35.9502 22.9199 36.2109 23.7725 36.2109 24.8682C36.2109 26.9951 35.2646 28.2285 33.3721 28.5684L33.0557 27.083C33.6533 26.9482 34.1162 26.6758 34.4443 26.2656C34.7725 25.8496 34.9365 25.375 34.9365 24.8418C34.9365 24.3086 34.7871 23.8662 34.4883 23.5146C34.1836 23.1572 33.7969 22.9785 33.3281 22.9785C32.9648 22.9785 32.6484 23.0898 32.3789 23.3125C32.1094 23.5352 31.9424 23.7725 31.8779 24.0244C31.8076 24.2764 31.7725 24.7334 31.7725 25.3955C31.7725 25.4482 31.7754 25.5684 31.7812 25.7559Z"
            fill="#FFFEFF"
          />
        </g>
        <g>
          <path
            d="M23 180.058V178.596C24.5447 179.353 25.6222 179.923 26.2323 180.308C26.8424 180.692 27.7705 181.372 29.0167 182.346V154H30.9833V182.346C32.3853 181.026 34.3908 179.763 37 178.558V180.038C35.1307 181.692 33.7093 183.115 32.7357 184.308C31.7752 185.5 30.9898 186.731 30.3797 188H29.484C29.0037 186.897 28.2703 185.724 27.2837 184.481C26.3102 183.237 24.8822 181.763 23 180.058Z"
            fill="#FFFEFF"
          />
        </g>
        <g class="rects">
          <rect x="29" y="139" width="2" height="10" fill="#FFFEFF" />
        </g>
        <g class="rects">
          <rect x="29" y="129" width="2" height="5" fill="#FFFEFF" />
        </g>
      </svg>
    </div>
  </div>
  <div :class="[{ ru: lang !== 0 }, 'second-row', 'text-block', 'section']">
    <div class="inner">
      <h2
        v-html="
          divideTextNormal(lang === 0 ? text.second.h2 : text.second.ru.h2)
        "
        :class="{ 'h2-ru': lang === 1 }"
      />
      <h4
        v-if="lang === 1"
        v-html="
          divideTextNormal(
            'Благодаря нашим разработкам, мы можем интегрировать 3D в браузеры.'
          )
        "
        class="h4-ru special-ru"
      />
      <div class="line">
        <h4
          v-html="divideTextNormal('А значит:')"
          v-if="lang === 1"
          class="h4-ru"
        />
        <div class="svg"></div>
        <svg
          width="83"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          class="zero anime"
          viewBox="0 0 83 30"
        >
          <g>
            <g id="svg_1">
              <path
                id="svg_2"
                fill="#FFFEFF"
                d="m1,0l11,0l-10,15l10,15l-11,0l0,-30z"
              />
            </g>
            <g id="svg_3">
              <path
                id="svg_4"
                fill="#FFFEFF"
                d="m25,0l23,0l-7,15l7,15l-23,0l-7,-15l7,-15z"
              />
            </g>
            <g id="svg_5">
              <path
                id="svg_6"
                fill="#FFFEFF"
                d="m58,0l13,0l-4,15l4,15l-13,0l-4,-15l4,-15z"
              />
            </g>
            <g id="svg_7">
              <path
                id="svg_8"
                fill="#FFFEFF"
                d="m78,0l3,0l-1,15l1,15l-3,0l-1,-15l1,-15z"
              />
            </g>
          </g>
        </svg>
      </div>
      <h4
        v-html="
          divideTextNormal(lang === 0 ? text.second.h4 : text.second.ru.h4)
        "
        :class="{ 'h4-ru': lang === 1 }"
      />
    </div>
  </div>
  <div class="third-row | image-block | section">
    <div class="inner">
      <svg
        width="742"
        height="478"
        viewBox="0 0 742 478"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :style="styleThird"
        class="ship posabs"
      >
        <path
          d="M2 5L3 2L6.5 1H17L29 3L59.5 11L104.5 27.5L130 39.5V29.5L187 8.5L486 167.5V204.5L534 182L586.5 208.5V224.5L602.5 233L601 284L605 285.5L679 329.5L719 365.5L740.5 389.5V396.5L737 399L732 436L726.5 445.5L706 461L669.5 476L632 467L595 454L569 443.5L543 430.5L425 360L419 361L337.5 310L213.5 234.5L91.5 155L43.5 112.5L23 79V73L13.5 51L4.5 21.5L4 14.5L2 5Z"
          stroke="#EE5C67"
          stroke-width="2"
          class="around"
        />
        <mask
          id="mask0_91_1414"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="2"
          y="1"
          width="739"
          height="475"
        >
          <path
            d="M2 5L3 2L6.5 1H17L29 3L59.5 11L104.5 27.5L130 39.5V29.5L187 8.5L486 167.5V204.5L534 182L586.5 208.5V224.5L602.5 233L601 284L605 285.5L679 329.5L719 365.5L740.5 389.5V396.5L737 399L732 436L726.5 445.5L706 461L669.5 476L632 467L595 454L569 443.5L543 430.5L425 360L419 361L337.5 310L213.5 234.5L91.5 155L43.5 112.5L23 79V73L13.5 51L4.5 21.5L4 14.5L2 5Z"
            fill="#C4C4C4"
          />
        </mask>
        <g mask="url(#mask0_91_1414)">
          <path
            opacity="0.5"
            d="M54.5215 -19.0001L-459.299 494.667M91.2229 -19.0001L-422.597 494.667M127.924 -19.0001L-385.896 494.667M164.626 -19.0001L-349.194 494.667M201.327 -19.0001L-312.493 494.667M238.028 -19.0001L-275.792 494.667M274.73 -19.0001L-239.09 494.667M311.431 -19.0001L-202.389 494.667M348.133 -19.0001L-165.688 494.667M384.834 -19.0001L-128.986 494.667M421.535 -19.0001L-92.2847 494.667M458.237 -19.0001L-55.5833 494.667M494.938 -19.0001L-18.882 494.667M531.64 -19.0001L17.8194 494.667M568.342 -19.0001L54.5208 494.667M605.043 -19.0001L91.2222 494.667M641.745 -19.0001L127.924 494.667M678.446 -19.0001L164.625 494.667M715.147 -19.0001L201.326 494.667M751.849 -19.0001L238.028 494.667M788.55 -19.0001L274.729 494.667M825.251 -19.0001L311.431 494.667M861.953 -19.0001L348.132 494.667M898.654 -19.0001L384.833 494.667M935.355 -19.0001L421.535 494.667M972.057 -19.0001L458.236 494.667M1008.76 -19.0001L494.937 494.667M1045.46 -19.0001L531.639 494.667M1082.16 -19.0001L568.34 494.667M1118.86 -19.0001L605.042 494.667M1155.56 -19.0001L641.743 494.667M1192.27 -19.0001L678.444 494.667M1228.97 -19.0001L715.146 494.667M17.8194 -19.0001L-496 494.667M1265.67 -19.0001L751.847 494.667"
            stroke="#EE5C67"
            stroke-width="2"
            class="lines"
          />
        </g>
      </svg>
      <div class="card">
        <div class="border"></div>
        <div class="row">
          <h4>{{ lang === 0 ? "Container ship" : "контейнеровоз" }}</h4>
          <h6>{{ lang === 0 ? "Cargo" : "груз" }}</h6>
        </div>
        <div class="row">
          <img src="../assets/img/cargo-ship.svg" alt="" />
        </div>
        <div class="row">
          <div class="attr">
            {{ lang === 0 ? "cargo weight" : "Вес груза" }}
          </div>
          <div class="attr">
            {{ anime.weight.toFixed(0) }} {{ lang === 0 ? "KG" : "КГ" }}
          </div>
        </div>
        <div class="row">
          <div class="attr">
            {{ lang === 0 ? "number of containers" : "количество контейнеров" }}
          </div>
          <div class="attr">
            {{ anime.container.toFixed(0) }} {{ lang === 0 ? "nc" : "шт" }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div :class="[{ ru: lang !== 0 }, 'how-row', 'text-block', 'section']">
    <div class="inner">
      <div class="line">
        <h4 v-html="divideTextNormal(lang === 0 ? 'how?' : 'как?')" />
        <div class="svg"></div>
        <svg
          width="83"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          class="zero anime"
          viewBox="0 0 83 30"
        >
          <g>
            <g id="svg_1">
              <path
                id="svg_2"
                fill="#FFFEFF"
                d="m1,0l11,0l-10,15l10,15l-11,0l0,-30z"
              />
            </g>
            <g id="svg_3">
              <path
                id="svg_4"
                fill="#FFFEFF"
                d="m25,0l23,0l-7,15l7,15l-23,0l-7,-15l7,-15z"
              />
            </g>
            <g id="svg_5">
              <path
                id="svg_6"
                fill="#FFFEFF"
                d="m58,0l13,0l-4,15l4,15l-13,0l-4,-15l4,-15z"
              />
            </g>
            <g id="svg_7">
              <path
                id="svg_8"
                fill="#FFFEFF"
                d="m78,0l3,0l-1,15l1,15l-3,0l-1,-15l1,-15z"
              />
            </g>
          </g>
        </svg>
      </div>
      <h2
        v-html="divideTextNormal(lang === 0 ? text.how.h2 : text.how.ru.h2)"
        :class="{ 'h2-ru': lang === 1 }"
      />
      <h4
        v-html="divideTextNormal(text.how.ru.h4)"
        v-if="lang === 1"
        :class="{ 'h4-ru': lang === 1 }"
      />
    </div>
  </div>
  <div class="motor | image-block | section">
    <div class="inner">
      <svg
        width="624"
        height="347"
        viewBox="0 0 624 347"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :style="`top: ${top[1]}px; left: ${left[1]}px; transform: scale(${scale})`"
        class="motor posabs"
      >
        <path
          d="M250.5 73L38.5 52.5L1 90V171.5L29.5 203L239 223.5L466 346H514L622.5 231V90L533.5 1H500.5L250.5 73Z"
          stroke="#EE5C67"
          stroke-width="2"
          class="around"
        />
        <mask
          id="mask0_114_382"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="1"
          y="1"
          width="622"
          height="345"
        >
          <path
            d="M250.5 73L38.5 52.5L1 90V171.5L29.5 203L239 223.5L466 346H514L622.5 231V90L533.5 1H500.5L250.5 73Z"
            fill="#C4C4C4"
          />
        </mask>
        <g mask="url(#mask0_114_382)">
          <path
            opacity="0.5"
            d="M4.52148 -83.0001L-509.299 430.667M41.2229 -83.0001L-472.597 430.667M77.9243 -83.0001L-435.896 430.667M114.626 -83.0001L-399.194 430.667M151.327 -83.0001L-362.493 430.667M188.028 -83.0001L-325.792 430.667M224.73 -83.0001L-289.09 430.667M261.431 -83.0001L-252.389 430.667M298.133 -83.0001L-215.688 430.667M334.834 -83.0001L-178.986 430.667M371.535 -83.0001L-142.285 430.667M408.237 -83.0001L-105.583 430.667M444.938 -83.0001L-68.882 430.667M481.64 -83.0001L-32.1806 430.667M518.342 -83.0001L4.52081 430.667M555.043 -83.0001L41.2222 430.667M591.745 -83.0001L77.9236 430.667M628.446 -83.0001L114.625 430.667M665.147 -83.0001L151.326 430.667M701.849 -83.0001L188.028 430.667M738.55 -83.0001L224.729 430.667M775.251 -83.0001L261.431 430.667M811.953 -83.0001L298.132 430.667M848.654 -83.0001L334.833 430.667M885.355 -83.0001L371.535 430.667M922.057 -83.0001L408.236 430.667M958.758 -83.0001L444.937 430.667M995.46 -83.0001L481.639 430.667M1032.16 -83.0001L518.34 430.667M1068.86 -83.0001L555.042 430.667M1105.56 -83.0001L591.743 430.667M1142.27 -83.0001L628.444 430.667M1178.97 -83.0001L665.146 430.667M-32.1806 -83.0001L-546 430.667M1215.67 -83.0001L701.847 430.667"
            stroke="#EE5C67"
            stroke-width="2"
            class="lines"
          />
        </g>
      </svg>
      <div class="card">
        <div class="border"></div>
        <div class="row">
          <h4>{{ lang === 0 ? "turbogenerator" : "Турбогенератор" }}</h4>
          <h6>ТC-6-2З Y3</h6>
        </div>
        <div class="row">
          <img src="../assets/img/motor.svg" alt="" />
        </div>
        <div class="row">
          <div class="attr">{{ lang === 0 ? "power" : "Мощность" }}</div>
          <div class="attr">{{ (6 * anime.motor) / 10 }} KW</div>
        </div>
        <div class="row">
          <div class="attr">{{ lang === 0 ? "Voltage" : "Напряжение" }}</div>
          <div class="attr">{{ anime.motor }} V</div>
        </div>
        <div class="row">
          <div class="attr">
            {{ lang === 0 ? "efficiency" : "эффективность" }}
          </div>
          <div class="attr">{{ Math.min(100, anime.motor / 100) }} %</div>
        </div>
      </div>
    </div>
  </div>
  <div :class="[{ ru: lang !== 0 }, 'goal', 'text-block', 'section']">
    <div class="inner">
      <h2
        v-html="divideTextNormal(lang === 0 ? text.goal.h2 : text.goal.ru.h2)"
        :class="{ 'h2-ru': lang === 1 }"
      />
      <div class="line">
        <div class="svg"></div>
        <svg
          width="83"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          class="zero anime"
          viewBox="0 0 83 30"
        >
          <g>
            <g id="svg_1">
              <path
                id="svg_2"
                fill="#FFFEFF"
                d="m1,0l11,0l-10,15l10,15l-11,0l0,-30z"
              />
            </g>
            <g id="svg_3">
              <path
                id="svg_4"
                fill="#FFFEFF"
                d="m25,0l23,0l-7,15l7,15l-23,0l-7,-15l7,-15z"
              />
            </g>
            <g id="svg_5">
              <path
                id="svg_6"
                fill="#FFFEFF"
                d="m58,0l13,0l-4,15l4,15l-13,0l-4,-15l4,-15z"
              />
            </g>
            <g id="svg_7">
              <path
                id="svg_8"
                fill="#FFFEFF"
                d="m78,0l3,0l-1,15l1,15l-3,0l-1,-15l1,-15z"
              />
            </g>
          </g>
        </svg>
      </div>
      <h4
        v-html="
          divideTextNormal(lang === 0 ? text.goal.p : text.goal.ru.p, true)
        "
        :class="{ 'h4-ru': lang === 1 }"
      />
    </div>
  </div>
  <div class="building | image-block | section" ref="building">
    <div class="inner">
      <svg
        width="1128"
        height="911"
        viewBox="0 0 1128 911"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :style="`top: ${top[2]}px; left: ${left[2]}px; transform: scale(${scale})`"
        class="building posabs"
      >
        <mask
          id="mask0_152_841"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="1128"
          height="911"
        >
          <path
            d="M1126 440.5L1123 524L946.5 635L905.5 620.5L906.5 658.5L820 712.5L608.5 630.5L605 529L493 580.5L526.5 594L535 754.5L263.5 909.5L24 787.5L2 623.5L77.5 591L67.5 586L65.5 561L90.5 551.5V548.5L61 535L58.5 510.5L83 500L76 497.5V494.5L55 486L52 460.5L77.5 450L70.5 447V442.5L48.5 434L44.5 408L70.5 398V391.5L41 380.5L38.5 353.5L64 344.5L56 342V336L35 328.5L31.5 301.5L57.5 292.5L49.5 289.5V281.5L27.5 273.5L24.5 246L50.5 237.5L49.5 227.5L20 217.5L17.5 189.5L43 181L35 178.5L33 151L41 148H43L265 86L361 110.5V126.5L377 131.5L381 130V128.5L370.5 125L369.5 105L373 104V100.5L378.5 99L376 66.5L366 63.5L364.5 43L374.5 40V37.5L400 29.5V24.5L479 3.5L488 5.5L501.5 1.5L510.5 3.5L513.5 2.5L530 5.5V7.5L556 13.5L560 12L575.5 15V17.5L587.5 20L598.5 16.5L614.5 20V26L630.5 29.5V32L637 33.5V45.5L646 48L647 67.5L631.5 72.5V83.5L648 88V108L633 113L639.5 116V125L649.5 127V148L636 153L641.5 154.5V164L651.5 166.5V186.5L636 193V201L651.5 205.5V226L639.5 230.5L644 232.5V241.5L653 244.5V263.5L641.5 268.5V269.5L645 271V278.5L654.5 282V301L639.5 307.5V314.5L655.5 319.5V339L641.5 345L647.5 348V354L656.5 357.5V362L697.5 374.5L750.5 350.5V349L769 340V334L749 327.5V306.5L769 297.5V290.5L749 284V262L762.5 256.5V248.5L767 245.5L748.5 240V217.5L765 210.5H767V202L747 196V173L762.5 166.5L767 168V156L747 149.5V128.5L753.5 125V119L745 115V81.5L763 75H765.5V59.5L775.5 56.5V48L791.5 41.5L804 45.5V32L875.5 8L972 27.5V33L1050 49.5V52.5L1062 55V78L1055 81V96.5L1048 99.5V121.5L1060 124.5V147.5L1047 153.5V164L1052 165.5V187.5L1049.5 188V189.5L1058 192.5V211.5L1045 220.5V255L1056.5 258.5V280.5L1044 287V295L1049 297V318L1055 322.5V344L1048 348V359.5L1042 362.5V383.5L1053 387.5V408L1042 414V415L1126 440.5Z"
            fill="#C4C4C4"
            stroke="#17DEDC"
            stroke-width="2"
          />
        </mask>
        <g mask="url(#mask0_152_841)">
          <path
            opacity="0.5"
            d="M292.522 -70L-701.867 924.235M329.223 -70L-665.166 924.235M365.925 -70L-628.464 924.235M402.626 -70L-591.763 924.235M439.327 -70L-555.061 924.235M476.029 -70L-518.36 924.235M512.73 -70L-481.659 924.235M549.432 -70L-444.957 924.235M586.133 -70L-408.256 924.235M622.834 -70L-371.554 924.235M659.536 -70L-334.853 924.235M696.237 -70L-298.152 924.235M732.938 -70L-261.45 924.235M769.641 -70L-224.749 924.235M806.342 -70L-188.048 924.235M843.043 -70L-151.346 924.235M879.745 -70L-114.645 924.235M916.446 -70L-77.9434 924.235M953.147 -70L-41.242 924.235M989.849 -70L-4.54059 924.235M1026.55 -70L32.1608 924.235M1063.25 -70L68.8622 924.235M1099.95 -70L105.564 924.235M1136.65 -70L142.265 924.235M1173.36 -70L178.966 924.235M1210.06 -70L215.668 924.235M1246.76 -70L252.369 924.235M1283.46 -70L289.07 924.235M1320.16 -70L325.772 924.235M1356.86 -70L362.473 924.235M1393.56 -70L399.175 924.235M1430.26 -70L435.876 924.235M1466.96 -70L472.577 924.235M255.82 -70L-738.568 924.235M1503.67 -70L509.279 924.235M1580.52 -70L586.133 924.235M1617.22 -70L622.834 924.235M1653.92 -70L659.536 924.235M1690.62 -70L696.237 924.235M1727.32 -70L732.939 924.235M1543.82 -70L549.432 924.235"
            stroke="#17DEDC"
            stroke-width="2"
            class="lines"
          />
        </g>
        <path
          d="M1126 440.5L1123 524L946.5 635L905.5 620.5L906.5 658.5L820 712.5L608.5 630.5L605 529L493 580.5L526.5 594L535 754.5L263.5 909.5L24 787.5L2 623.5L77.5 591L67.5 586L65.5 561L90.5 551.5V548.5L61 535L58.5 510.5L83 500L76 497.5V494.5L55 486L52 460.5L77.5 450L70.5 447V442.5L48.5 434L44.5 408L70.5 398V391.5L41 380.5L38.5 353.5L64 344.5L56 342V336L35 328.5L31.5 301.5L57.5 292.5L49.5 289.5V281.5L27.5 273.5L24.5 246L50.5 237.5L49.5 227.5L20 217.5L17.5 189.5L43 181L35 178.5L33 151L41 148H43L265 86L361 110.5V126.5L377 131.5L381 130V128.5L370.5 125L369.5 105L373 104V100.5L378.5 99L376 66.5L366 63.5L364.5 43L374.5 40V37.5L400 29.5V24.5L479 3.5L488 5.5L501.5 1.5L510.5 3.5L513.5 2.5L530 5.5V7.5L556 13.5L560 12L575.5 15V17.5L587.5 20L598.5 16.5L614.5 20V26L630.5 29.5V32L637 33.5V45.5L646 48L647 67.5L631.5 72.5V83.5L648 88V108L633 113L639.5 116V125L649.5 127V148L636 153L641.5 154.5V164L651.5 166.5V186.5L636 193V201L651.5 205.5V226L639.5 230.5L644 232.5V241.5L653 244.5V263.5L641.5 268.5V269.5L645 271V278.5L654.5 282V301L639.5 307.5V314.5L655.5 319.5V339L641.5 345L647.5 348V354L656.5 357.5V362L697.5 374.5L750.5 350.5V349L769 340V334L749 327.5V306.5L769 297.5V290.5L749 284V262L762.5 256.5V248.5L767 245.5L748.5 240V217.5L765 210.5H767V202L747 196V173L762.5 166.5L767 168V156L747 149.5V128.5L753.5 125V119L745 115V81.5L763 75H765.5V59.5L775.5 56.5V48L791.5 41.5L804 45.5V32L875.5 8L972 27.5V33L1050 49.5V52.5L1062 55V78L1055 81V96.5L1048 99.5V121.5L1060 124.5V147.5L1047 153.5V164L1052 165.5V187.5L1049.5 188V189.5L1058 192.5V211.5L1045 220.5V255L1056.5 258.5V280.5L1044 287V295L1049 297V318L1055 322.5V344L1048 348V359.5L1042 362.5V383.5L1053 387.5V408L1042 414V415L1126 440.5Z"
          stroke="#17DEDC"
          stroke-width="2"
          class="around"
        />
      </svg>
      <div class="card">
        <div class="border"></div>
        <div class="row">
          <h4>{{ lang === 0 ? "residential sector" : "жилой комплекс" }}</h4>
          <h6>{{ lang === 0 ? "Carleton" : "" }}</h6>
        </div>
        <div class="row">
          <img src="../assets/img/plan.svg" alt="" />
        </div>
        <div class="row">
          <div class="attr">
            {{ lang === 0 ? "number of apartments" : "количество квартир" }}
          </div>
          <div class="attr">216</div>
        </div>
        <div class="row">
          <div class="attr">
            {{ lang === 0 ? "energy consumption" : "потребление энергии" }}
          </div>
          <div class="attr">
            {{ anime.motor / 10 }} {{ lang === 0 ? "KW" : "квт" }}
          </div>
        </div>
        <div class="row">
          <div class="attr">
            {{ lang === 0 ? "parking spaces" : "парковочные места" }}
          </div>
          <div class="attr">332</div>
        </div>
      </div>
    </div>
  </div>
  <div :class="[{ ru: lang !== 0 }, 'sector', 'text-block', 'section']">
    <div class="inner">
      <h2
        v-html="
          divideTextNormal(lang === 0 ? text.sector.h2 : text.sector.ru.h2)
        "
        :class="{ 'h2-ru': lang === 1 }"
      />
      <h4 class="special">
        <div
          v-for="sector in lang === 0
            ? text.sector.sectors
            : text.sector.ru.sectors"
          :key="sector"
          v-html="
            `<span class='dot letter'>•</span><span class='letter letter-desktop'>&nbsp;</span>${divideTextNormal(
              sector
            )}`
          "
        ></div>
      </h4>
      <div class="line">
        <div class="svg"></div>
        <svg
          width="83"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          class="zero anime"
          viewBox="0 0 83 30"
        >
          <g>
            <g id="svg_1">
              <path
                id="svg_2"
                fill="#FFFEFF"
                d="m1,0l11,0l-10,15l10,15l-11,0l0,-30z"
              />
            </g>
            <g id="svg_3">
              <path
                id="svg_4"
                fill="#FFFEFF"
                d="m25,0l23,0l-7,15l7,15l-23,0l-7,-15l7,-15z"
              />
            </g>
            <g id="svg_5">
              <path
                id="svg_6"
                fill="#FFFEFF"
                d="m58,0l13,0l-4,15l4,15l-13,0l-4,-15l4,-15z"
              />
            </g>
            <g id="svg_7">
              <path
                id="svg_8"
                fill="#FFFEFF"
                d="m78,0l3,0l-1,15l1,15l-3,0l-1,-15l1,-15z"
              />
            </g>
          </g>
        </svg>
      </div>
      <h4
        v-html="divideTextNormal(lang === 0 ? text.sector.p : text.sector.ru.p)"
        :class="{ 'h4-ru': lang === 1 }"
      />
    </div>
  </div>
  <div class="train | image-block | section">
    <div class="inner">
      <svg
        width="1187"
        height="431"
        viewBox="0 0 1187 431"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :style="`top: ${top[3]}px; left: ${left[3]}px; transform: scale(${scale})`"
        class="train posabs"
      >
        <mask
          id="mask0_471_3705"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="1187"
          height="431"
        >
          <path
            d="M987.429 430.997L958.991 426.278L890.738 409.378L0 132.876V60.207L451.834 53.8186L484.156 32.3896L498.375 30.5022L510.699 16.3466L851.306 0.996582L974.946 5.14134L1018.71 12.0781L1050.94 27.1773L1080.33 60.2071C1093.28 70.2733 1120.14 91.3493 1123.94 95.1242C1128.67 99.8427 1144.79 124.379 1149.53 132.872C1154.27 141.366 1179.86 202.706 1181.76 210.256C1183.28 216.296 1185.55 254.295 1186.5 272.54V396.033L1173.23 415.85L987.429 430.997Z"
            fill="#17DEDC"
          />
        </mask>
        <g mask="url(#mask0_471_3705)">
          <path
            class="lines"
            opacity="0.5"
            d="M338.224 -360.813L-772.964 751.612M379.237 -360.813L-731.952 751.612M420.249 -360.813L-690.94 751.612M461.261 -360.813L-649.927 751.612M502.274 -360.813L-608.915 751.612M543.286 -360.813L-567.903 751.612M584.298 -360.813L-526.89 751.612M625.311 -360.813L-485.878 751.612M666.323 -360.813L-444.866 751.612M707.335 -360.813L-403.854 751.612M748.347 -360.813L-362.841 751.612M789.36 -360.813L-321.829 751.612M830.372 -360.813L-280.817 751.612M871.385 -360.813L-239.804 751.612M912.397 -360.813L-198.792 751.612M953.41 -360.813L-157.78 751.612M994.422 -360.813L-116.768 751.612M1035.43 -360.813L-75.7552 751.612M1076.45 -360.813L-34.7429 751.612M1117.46 -360.813L6.26942 751.612M1158.47 -360.813L47.2817 751.612M1199.48 -360.813L88.294 751.612M1240.5 -360.813L129.306 751.612M1281.51 -360.813L170.319 751.612M1322.52 -360.813L211.331 751.612M1363.53 -360.813L252.343 751.612M1404.54 -360.813L293.355 751.612M1445.56 -360.813L334.368 751.612M1486.57 -360.813L375.38 751.612M1527.58 -360.813L416.392 751.612M1568.59 -360.813L457.405 751.612M1609.6 -360.813L498.417 751.612M1650.62 -360.813L539.429 751.612M297.211 -360.813L-813.977 751.612M1691.63 -360.813L580.442 751.612M1777.51 -360.813L666.323 751.612M1818.52 -360.813L707.335 751.612M1859.53 -360.813L748.348 751.612M1900.55 -360.813L789.36 751.612M1941.56 -360.813L830.372 751.612M1736.5 -360.813L625.311 751.612"
            stroke="#1FD465"
            stroke-width="2"
          />
        </g>
        <path
          class="around"
          d="M452.032 54.8209L452.325 54.8168L452.57 54.6546L484.714 33.353L498.71 31.4959L499.085 31.4462L499.333 31.1613L511.38 17.3287L851.667 1.99978L975.259 6.14115L1018.84 13.0461L1050.77 27.9982L1080.04 60.8744L1080.1 60.9429L1080.17 60.9993C1086.65 66.0309 1096.6 73.8141 1105.41 80.8103C1114.25 87.8331 1121.86 93.9987 1123.7 95.8354C1124.82 96.9505 1126.68 99.3053 1128.93 102.409C1131.18 105.492 1133.78 109.255 1136.38 113.142C1141.59 120.922 1146.79 129.152 1149.14 133.362C1151.48 137.546 1159.04 154.936 1166.28 172.305C1169.89 180.972 1173.42 189.606 1176.16 196.544C1178.91 203.518 1180.83 208.694 1181.29 210.502C1181.64 211.922 1182.07 215.345 1182.51 220.066C1182.95 224.752 1183.41 230.629 1183.84 236.893C1184.72 249.409 1185.53 263.45 1186 272.569V395.731L1173.16 414.895L987.885 429.992L959.594 425.3L891.379 408.416L2.49902 132.139V61.1956L452.032 54.8209Z"
          stroke="#1FD465"
          stroke-width="2"
        />
      </svg>
      <div class="card">
        <div class="border"></div>
        <div class="row">
          <h4>{{ lang === 0 ? "high-speed train" : "Скоросной поезд" }}</h4>
          <h6>TGV</h6>
        </div>
        <div class="row">
          <img src="../assets/img/trains.svg" alt="" />
        </div>
        <div class="row">
          <div class="attr">{{ lang === 0 ? "Power" : "общая мощность" }}</div>
          <div class="attr">9600 {{ lang === 0 ? "kW" : "квт" }}</div>
        </div>
        <div class="row">
          <div class="attr">
            {{ lang === 0 ? "MAX.SPEED" : "макс. скорость" }}
          </div>
          <div class="attr">320 {{ lang === 0 ? "KM/H" : "КМ/Ч" }}</div>
        </div>
        <div class="row">
          <div class="attr">
            {{ lang === 0 ? "Number of passengers" : "количество пассажиров" }}
          </div>
          <div class="attr">346</div>
        </div>
      </div>
    </div>
  </div>
  <div :class="[{ ru: lang !== 0 }, 'form', 'text-block', 'section']">
    <div class="inner">
      <h2
        v-html="divideTextNormal(lang === 0 ? text.form.h2 : text.form.ru.h2)"
      />
      <div class="line">
        <div class="svg"></div>
        <svg
          width="83"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          class="zero anime"
          viewBox="0 0 83 30"
        >
          <g>
            <g id="svg_1">
              <path
                id="svg_2"
                fill="#FFFEFF"
                d="m1,0l11,0l-10,15l10,15l-11,0l0,-30z"
              />
            </g>
            <g id="svg_3">
              <path
                id="svg_4"
                fill="#FFFEFF"
                d="m25,0l23,0l-7,15l7,15l-23,0l-7,-15l7,-15z"
              />
            </g>
            <g id="svg_5">
              <path
                id="svg_6"
                fill="#FFFEFF"
                d="m58,0l13,0l-4,15l4,15l-13,0l-4,-15l4,-15z"
              />
            </g>
            <g id="svg_7">
              <path
                id="svg_8"
                fill="#FFFEFF"
                d="m78,0l3,0l-1,15l1,15l-3,0l-1,-15l1,-15z"
              />
            </g>
          </g>
        </svg>
      </div>
      <form @submit="submit">
        <input type="hidden" name="form-name" value="single" />
        <div class="col">
          <InputItem
            :lang="lang"
            :inputPlaceHolder="lang === 0 ? `Name` : 'Имя'"
            v-model="name"
            :error="errorName"
            :required="true"
            :type="'name'"
          />
          <InputItem
            :lang="lang"
            :inputPlaceHolder="lang === 0 ? `Email` : 'Почта'"
            v-model="email"
            :error="errorEmail"
            :required="true"
            :type="'email'"
          />
          <InputItem
            :lang="lang"
            :inputPlaceHolder="lang === 0 ? `Phone` : 'Телефон'"
            v-model="phone"
            :type="'tel'"
            :required="false"
          />
        </div>
        <div class="col">
          <InputItem
            :lang="lang"
            :inputPlaceHolder="
              lang === 0 ? `Enter your message` : 'Ваше сообщение'
            "
            v-model="message"
            :type="'text'"
            :required="false"
            :textarea="true"
            :width="width"
          />
          <button class="submit" :disabled="submitInProgress" type="submit">
            <div class="bg" />
            <span>{{
              sendText === false
                ? lang === 0
                  ? "send information"
                  : "отправить"
                : lang === 0
                ? "done!"
                : "отправлено!"
            }}</span>
            <div class="letter">
              <img src="../assets/img/letter.png" alt="" />
            </div>
          </button>
        </div>
      </form>
    </div>
  </div>
  <div class="last-row">
    <div>
      <h3
        v-html="
          divideTextNormal(lang === 0 ? 'Batumi, Georgia' : 'Батуми, Грузия')
        "
      />
      <h2
        v-html="
          divideTextNormal(
            lang === 0 ? 'General Questions' : 'пишите нам на почту'
          )
        "
        :class="{ 'h2-ru': lang === 1 }"
      />
      <a
        href="mailto:hello@archimatika.agency"
        v-html="divideTextNormal('hello@archimatika.agency')"
      />
    </div>
  </div>
  <div :class="[{ active: showMenu }, 'menu']">
    <div class="middle">
      <a v-for="link in modalLinks" :key="`modal${link.id}`" :href="link.href"
        ><span>{{ lang === 0 ? link.name : link.nameRu }}</span></a
      >
    </div>
    <div class="bottom">
      <button id="modal1" @click="showMenu = false">
        <span>{{ lang === 0 ? bottomLink.name : bottomLink.nameRu }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import { gsap } from "gsap";
import text from "../json/text.json";
import InputItem from "../components/InputItem";
import axios from "axios";

export default {
  name: "UI",
  props: {
    frame: {
      type: Number,
      default: 0,
    },
    anime: {
      type: Object,
      default() {
        return { second: 0 };
      },
    },
    posabs: {
      type: Object,
      default() {
        return {
          ship: 10000,
          motor: 10000,
          building: 10000,
          train: 10000,
        };
      },
    },
    lang: {
      type: Number,
      default: 0,
    },
  },
  components: {
    InputItem,
  },
  data() {
    return {
      formOpacityValue: 1,
      text: {},
      name: "",
      email: "",
      phone: "",
      message: "",
      errorName: false,
      errorEmail: false,
      submitInProgress: false,
      sendText: false,
      showMenu: false,
      width: 1920,
      links: [
        {
          name: "Real estate",
          nameRu: "Недвижимость",
          id: 2,
          href: "https://real-estate.archimatika.dev",
          hrefRu: "https://re-ru.archimatika.dev",
          idClass: "linkRealEstate",
        },
        {
          name: "Agency",
          nameRu: "Агенство",
          id: 3,
          href: "https://archimatika.agency",
          hrefRu: "https://ru.archimatika.agency",
          idClass: "linkAgency",
        },
        {
          name: "Let’s get in touch",
          nameRu: "Начать проект",
          id: 1,
          href: "#",
          hrefRu: "#",
          idClass: "formLink",
        },
      ],
      initialTop: [
        {
          desktop: 552,
          tablet: 546,
          mobile: 545,
        },
        {
          desktop: 502,
          tablet: 511,
          mobile: 522,
        },
        {
          desktop: 138,
          tablet: 226,
          mobile: 340,
        },
        {
          desktop: 352,
          tablet: 390,
          mobile: 444,
        },
      ],
      initialLeft: [
        {
          desktop: 584,
          tablet: 108,
          mobile: 110,
        },
        {
          desktop: 766,
          tablet: 233,
          mobile: 196,
        },
        {
          desktop: 88,
          tablet: -275,
          mobile: -134,
        },
        {
          desktop: -378,
          tablet: -638,
          mobile: -365,
        },
      ],
      top: [0, 0, 0, 0],
      left: [0, 0, 0, 0],
      scale: 1,
    };
  },
  created() {
    this.text = text;
    window.addEventListener("resize", this.resize, false);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.resize, false);
  },
  mounted() {
    let finished = false;
    const hover = gsap.timeline({ paused: true });
    hover.to(".arrow-top svg .main-svg rect", {
      scaleY: 0.87,
      duration: 0.5,
      fill: "rgba(255, 254, 255, 0)",
      transformOrigin: "100% 100%",
    });
    hover.to(
      ".arrow-top svg .text path",
      {
        y: "22.5%",
        duration: 0.5,
        transformOrigin: "100% 100%",
      },
      "<"
    );
    hover.to(
      ".arrow-top svg .rects rect",
      {
        scale: 0,
        duration: 0.5,
        transformOrigin: "100% 100%",
      },
      "<"
    );
    const hoverEl = document.querySelector(".arrow-top svg");

    function isPhone() {
      return !!(
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      );
    }

    if (!isPhone()) {
      hoverEl.addEventListener("mouseover", () =>
        finished ? hover.play() : ""
      );
      hoverEl.addEventListener("mouseout", () =>
        finished ? hover.reverse() : ""
      );
    }

    function overflow(bool) {
      if (bool) {
        document.getElementsByTagName("html")[0].classList.add("overflow");
        document.getElementsByTagName("body")[0].classList.add("overflow");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("overflow");
        document.getElementsByTagName("body")[0].classList.remove("overflow");
        finished = true;
      }
    }

    overflow(true);
    const tlInitial = gsap.timeline({ paused: true, onComplete: overflow });
    const links = document.getElementsByClassName("link-span");
    const h1 = document.getElementById("h1");
    const h2 = document.getElementById("h2");
    const letters =
      this.lang === 0
        ? h1.getElementsByTagName("div")
        : h1.getElementsByTagName("span");
    const letters2 = h2.getElementsByClassName("soon");
    const letters3 = h2.getElementsByClassName("late");
    const svg = h2.getElementsByTagName("svg")[0];
    const stagger = 0.03;
    const duration = 21 * stagger;
    const root = document.documentElement;
    tlInitial.from(letters, {
      opacity: 0,
      stagger: stagger,
    });
    tlInitial.from(
      "header img",
      {
        opacity: 0,
        y: "-400%",
        duration,
      },
      "<"
    );
    tlInitial.from(
      "header .circle",
      {
        stagger: stagger * 10,
        opacity: 0,
        y: "-400%",
        duration,
      },
      `<${stagger}`
    );
    tlInitial.from(
      links,
      {
        stagger: stagger * 10,
        opacity: 0,
        y() {
          let vw = parseFloat(
            root.style.getPropertyValue("--vw").replace("px", "")
          );
          return `${-2.6 * vw}px`;
        },
        duration,
      },
      "<0.4"
    );
    tlInitial.from(
      ".top-row .title",
      {
        y: "100%",
        duration,
      },
      "<-0.4"
    );
    tlInitial.from(
      letters2,
      {
        opacity: 0,
        stagger: stagger * 0.5,
        clearProps: true,
      },
      "<0.15"
    );
    tlInitial.from(
      letters3,
      {
        opacity: 0,
        stagger: stagger * 0.5,
        clearProps: true,
      },
      "<0.15"
    );
    tlInitial.from(
      svg,
      {
        opacity: 0,
        rotation: "360deg",
        scale: 3,
        duration: 0.6,
        clearProps: true,
      },
      "<0.05"
    );
    tlInitial.to(
      ".top-row",
      {
        backgroundColor: "transparent",
        duration: 0.5,
      },
      "-=0.5"
    );
    tlInitial.from(
      ".overlay",
      {
        y: "-100%",
        duration: 0.5,
      },
      "<-0.3"
    );
    tlInitial.from(
      ".arrow-top svg .main-svg rect",
      {
        scaleY: 0,
        duration: 0.5,
        clearProps: "all",
      },
      "<-0.5"
    );
    tlInitial.from(
      [".arrow-top svg g path", ".arrow-top svg g:not(.main-svg) rect"],
      {
        fill: "#000",
        stagger: stagger * 5,
        duration: 0.5,
        y: "-100%",
        clearProps: "all",
      },
      "=-0.3"
    );

    const interval = setInterval(() => {
      const loading = document.getElementById("loadingScreen");
      if (!loading) {
        clearInterval(interval);
        tlInitial.play();
        this.resize();
      }
    }, 10);
  },
  computed: {
    modalLinks() {
      return this.links.filter((a) => a.id !== 1);
    },
    bottomLink() {
      return this.links.filter((a) => a.id === 1)[0];
    },
    styleThird() {
      return `top: ${this.top[0]}px; left: ${this.left[0]}px; transform: scale(${this.scale})`;
    },
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      const validateEmail = (email) => {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };
      if (this.name === "") {
        this.errorName = true;
      }
      if (this.email === "") {
        this.errorEmail = true;
      }
      if (!validateEmail(this.email)) {
        this.errorEmail = true;
      } else {
        if (this.name !== "") {
          this.errorName = false;
          this.errorEmail = false;
          try {
            await axios.post(
              "https://api.hsforms.com/submissions/v3/integration/submit/20385541/4e2431ac-28e5-4d49-9ed7-24c0f73714ea",
              {
                submittedAt: new Date(),
                fields: [
                  {
                    name: "email",
                    value: this.email,
                  },
                  {
                    name: "firstname",
                    value: this.name,
                  },
                  {
                    name: "phone",
                    value: this.phone,
                  },
                  {
                    name: "message",
                    value: this.message,
                  },
                ],
                context: {
                  hutk: document.cookie.replace(
                    /(?:^|.*;\s*)hubspotutk\s*=\s*([^;]*).*$|^.*$/,
                    "$1"
                  ),
                  pageUri: location.href.replace(/https?:\/\//i, ""),
                  pageName: "Archimatika Contacts",
                },
              }
            );
            const tl = gsap.timeline();
            tl.to(".submit .bg", {
              backgroundColor: "transparent",
            });
            tl.to(".submit .bg", {
              x: "-110%",
              backgroundColor: "white",
              duration: 0,
            });
            tl.to(".submit .letter", {
              y: "-50%",
            });
            tl.to(
              ".submit span",
              {
                y: "-300%",
              },
              "<"
            );
            tl.to(".submit .bg", {
              x: "-50%",
            });
            tl.to(this, {
              sendText: true,
              duration: 0,
            });
            tl.to(".submit .bg", {
              delay: 0.5,
              x: "0%",
            });
            tl.to(".submit .bg", {
              backgroundColor: "transparent",
            });
            tl.to(
              ".submit .letter",
              {
                y: "150%",
              },
              "<"
            );
            tl.to(
              ".submit span",
              {
                y: "0%",
              },
              "<"
            );
            this.submitInProgress = true;
            this.name = "";
            this.email = "";
            this.phone = "";
            this.message = "";
            this.$gtag.event('form_submitted');
            setTimeout(() => {
              this.submitInProgress = false;
              this.sendText = false;
            }, 8000);
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    divideText(text, position, br) {
      let finalText = "";
      text.split("", text.length).forEach((l, index) => {
        if (l !== " ") {
          if (index <= position) {
            finalText += `<div class="soon">${l}</div>`;
          } else {
            finalText += `<div class="late">${l}</div>`;
          }
        } else {
          if (position > 1 && index === position) {
            finalText += `<br class="mobile" /><svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" > <g style="mix-blend-mode: difference"> <circle cx="50" cy="50" r="50" fill="#FFFEFF"/> </g> <g style="mix-blend-mode: difference"> <path d="M66.2389 58.3901C69.89 53.8923 71.9062 47.8772 71.9062 40.8326H63.1328C63.1328 45.1136 62.3155 48.7985 60.6807 51.7247L47.4389 36.0097H65.1491V28.3689H35.396V32.108L44.1149 43.2169V45.3845C42.3711 43.4879 40.0824 42.0247 36.5948 42.0247C31.745 42.0247 26.2412 45.1136 26.2412 52.4834C26.2412 62.1292 34.0882 67.1146 46.0221 67.1146C51.5259 67.1146 56.3212 65.8683 60.1902 63.5923L66.8384 71.9917L73.7589 67.3314L66.2389 58.3901ZM46.0221 59.4739C38.7746 59.4739 35.0146 57.3605 35.0146 52.8085C35.0146 49.1236 38.0661 47.2812 41.8262 47.2812C45.8041 47.2812 48.6922 48.961 52.0163 53.1879L55.2314 57.2521C52.7247 58.7152 49.6186 59.4739 46.0221 59.4739Z" fill="#ffffff"/></g></svg><br class="mobile" />`;
          } else {
            finalText += `<div${
              index === br ? ' class="letter-mobile"' : ""
            }>&nbsp;</div>${index === br ? '<br class="mobile" />' : ""}`;
          }
        }
      });
      return finalText;
    },
    divideTextNormal(text, bool) {
      let finalText = "";
      // add dot at the beginning of the text
      if (bool)
        finalText +=
          '<span class="dot letter">•</span><span class="letter letter-desktop"> </span>';
      text.split("", text.length).forEach((l) => {
        if (l !== " ") {
          if (l === "<") {
            finalText += `<br />${
              bool === true
                ? '<br class="tablet"/><span class="dot letter">•</span>'
                : ""
            }`;
            finalText += `<span class="letter letter-desktop"> </span>`;
          } else if (l === ">") {
            finalText += `<span class="letter letter-tablet"> </span><br class="tablet"/>`;
          } else if (l === "/") {
            finalText += `<span class="letter letter-tablet-desktop"> </span><br class="tablet-desktop"/>`;
          } else if (l === "%") {
            finalText += `<span class="letter letter-mobile"> </span><br class="mobile"/>`;
          } else {
            finalText += `<span class="letter">${l}</span>`;
          }
        } else {
          finalText += `<span class="letter"> </span>`;
        }
      });
      return finalText;
    },
    resize() {
      this.width = window.innerWidth;
      const ratio = window.innerWidth / window.innerHeight;
      let ratioCoefficient = 1;
      if (ratio < 0.69) {
        ratioCoefficient = (0.388 / 0.75) * 0.96;
      } else if (ratio >= 1) {
        ratioCoefficient = 0.388 / 0.388;
      } else if (ratio < 1 && ratio >= 0.69) {
        ratioCoefficient = 0.388 / 0.5;
      }
      const canvas = document.getElementById("canvas");
      const height = canvas.offsetHeight;
      const width = canvas.offsetWidth;
      this.scale = (height / 1080) * ratioCoefficient;
      for (let i = 1; i <= this.left.length; i++) {
        this.left[i - 1] = this.calculateLeft(
          this.initialLeft[i - 1][
            `${
              ratioCoefficient === 1
                ? "desktop"
                : ratioCoefficient === 0.388 / 0.5
                ? "tablet"
                : "mobile"
            }`
          ],
          width,
          height
        );
        this.top[i - 1] = this.calculateTop(
          this.initialTop[i - 1][
            `${
              ratioCoefficient === 1
                ? "desktop"
                : ratioCoefficient === 0.388 / 0.5
                ? "tablet"
                : "mobile"
            }`
          ],
          height
        );
      }
    },
    calculateTop(initial, height) {
      return initial / (1080 / height);
    },
    calculateLeft(initial, width, height) {
      const heightRatio = height / 1080;
      const ratio = window.innerWidth / window.innerHeight;
      let widthCoefficient = 1920;
      if (ratio < 0.69) {
        widthCoefficient = 600;
      } else if (ratio >= 1) {
        widthCoefficient = 1920;
      } else if (ratio < 1 && ratio >= 0.69) {
        widthCoefficient = 800;
      }
      return (
        initial * heightRatio - (heightRatio * widthCoefficient - width) / 2
      );
    },
  },
  watch: {
    name() {
      this.errorName = false;
    },
    email() {
      this.errorEmail = false;
    },
  },
};
</script>
<style lang="stylus">
// desktop css
@require '../assets/css/base.styl'
br.tablet
  display none

.letter-desktop, .letter-tablet-desktop
  display none

.letter-mobile
  display inline

br.mobile
  display none

br.tablet-desktop
  display block

.section
  position relative
  width 100%
  height var(--height)

  .inner
    height 100vh
    display flex
    justify-content center
    flex-direction column
    position relative

header
  fixedPosition(true)
  centerFlex(true, false)
  position fixed
  justify-content flex-start
  mix-blend-mode difference
  z-index 5
  padding-right 0
  height calc(var(--vw) * 4.69)
  padding-top calc(var(--vw) * 2.71)
  width calc(var(--vw) * 77.03)

  svg
    display none

  img
    mix-blend-mode difference
    height calc(var(--vw) * 0.89)
    cursor pointer

  a
    font(calc(var(--vw) * .83), true, false, 400)
    text-decoration underline
    position relative
    line-height 1.5
    margin-left auto
    display flex
    align-items center

    .circle
      width calc(var(--vw) * .52)
      height calc(var(--vw) * .52)
      margin-right calc(var(--vw) * 1.04)
      border-radius 50%
      background $white
      mix-blend-mode difference
      position relative

      &:after
        content ''
        position absolute
        top 50%
        left 50%
        transform translateY(-50%) translateX(-50%)
        border 1px solid white
        width 0
        height 0
        border-radius 50%
        transition 0.3s width ease-in-out, .3s height ease-in-out

    span
      display block

    &:hover
      @media (min-width 1280px)
        .circle
          &:after
            width 600%
            height 600%

.top-row
  height var(--height)
  width 100%
  background-color $white
  fixedPosition(true)

  .overlay
    width 100%
    position absolute
    top 0
    left 0
    background linear-gradient(180deg, #2C2C2C 72.07%, rgba(44, 44, 44, 0) 100%)
    height calc(var(--vw) * 45.52)

  .title
    base3D()
    centerFlex(true, true)
    position relative
    mix-blend-mode difference
    padding-top calc(var(--vw) * 10.52)

    h1
      font(calc(var(--vw) * 7.03), true, true, 700)
      line-height 1.15
      centerFlex(false, false)
      position relative

      &.h1-ru
        display block
        font-size calc(var(--vw) * 3.75)

    h2
      font(calc(var(--vw) * 2.66), true, true, 700)
      line-height 1.15
      centerFlex(true, false)
      position relative
      margin-right calc(var(--vw) * 6.77)

      svg
        margin-top calc(var(--vw) * -1.33)
        width calc(var(--vw) * 5.21)
        height calc(var(--vw) * 5.21)
        mix-blend-mode difference

.arrow-top
  height fit-content
  width 100%
  mix-blend-mode difference
  top calc(var(--vw) * 30.65)
  left 0
  fixedPosition(false)
  position absolute
  centerFlex(true, false)
  z-index 2

  svg
    height calc(var(--vw) * 10.42)
    width calc(var(--vw) * 3.31)

    g
      mix-blend-mode: difference

.text-block
  base3D()
  fixedPosition(false)
  centerFlex(true, true)
  justify-content flex-start
  mix-blend-mode difference

  h2
    font(calc(var(--vw) * 3.75), true, true, 700)
    line-height 1.15
    width 100%

    &.h2-ru
      font-size calc(var(--vw) * 3.75)

  h4
    font(calc(var(--vw) * 1.87), true, true, 700)
    line-height 1.4

    &.h4-ru
      font-size calc(var(--vw) * 1.88)
      width 100%
      line-height 1.4

  .line
    margin calc(var(--vw) * 3.13) 0
    display flex
    justify-content flex-start
    width 100%
    overflow hidden

    .svg
      width 100%
      height 30px
      mix-blend-mode: difference
      background white

    .zero
      width 83px
      height 30px
      min-height 30px
      min-width 83px
      display block
      margin-left -2px

.image-block
  svg.posabs
    position absolute
    transform-origin 0 0
    z-index 0

    &.ship
      width 770px
      height 495px

      .around, .lines
        stroke-dasharray 2000
        stroke-dashoffset 2000

    &.motor
      width 580px
      height 322px

      .around, .lines
        stroke-dasharray 2000
        stroke-dashoffset 2000

    &.building
      width 1126px
      height 908px

      .around, .lines
        stroke-dasharray 10000
        stroke-dashoffset 10000

    &.train
      width 1426px
      height 479px

      .around, .lines
        stroke-dasharray 10000
        stroke-dashoffset 10000

.second-row
  h2, h4, .line
    max-width calc(var(--vw) * 66.93)

  h4
    width 100%

    &.special-ru
      margin-top calc(var(--vw) * 3.13)

  .line
    h4.h4-ru
      line-height 30px
      width auto
      min-width calc(var(--vw) * 11.05)

  &.ru
    h2, h4, .line
      max-width calc(var(--vw) * 83.03)

.third-row
  .card
    top 60%
    left 70%
    transform translate(-50%, -50%)
    height calc(var(--vw) * 17.92)

.card
  width calc(var(--vw) * 29.11)
  background #2C2C2CCC
  position absolute
  padding calc(var(--vw) * 2.08)
  overflow hidden

  .border
    width calc(100% + (4.17 * var(--vw)))
    margin-left calc(var(--vw) * -2.08)
    margin-top calc(var(--vw) * -2.08)
    margin-bottom calc(var(--vw) * 2.08)
    height 0.01%
    min-height 2px
    background linear-gradient(0deg, rgba(221, 221, 28, 0) 0%, rgba(221, 221, 28, 1) 40%, rgba(221, 221, 28, 1) 100%)

  .row
    display flex
    justify-content space-between
    align-items center

    &:nth-child(2), &:nth-child(3)
      margin-bottom calc(var(--vw) * 1.04)

    &:nth-child(4), &:nth-child(5), &:nth-child(6)
      margin-bottom calc(var(--vw) * 0.52)

    &:last-child
      margin-bottom 0

    img
      width 100%

    h4
      font(calc(var(--vw) * 1.87), true, true, 700)
      line-height 1.15

    h6
      font(calc(var(--vw) * 0.94), true, true, 700)
      line-height calc(var(--vw) * 1.67)

    .attr
      font(calc(var(--vw) * 0.94), true, true, 700)
      line-height 1.78

.how-row
  h2, h4, .line
    max-width calc(var(--vw) * 66.93)

  &.ru
    h2, h4, .line
      max-width calc(var(--vw) * 59.93)

  h2
    margin-top calc(var(--vw) * 3.13)

    &.h2-ru
      margin-bottom calc(var(--vw) * 3.13)

  .line
    h4
      line-height 30px
    margin 0

    .svg
      margin-left 6px

.motor
  .card
    top 50%
    left 20%
    transform translate(-50%, -50%)
    height calc(var(--vw) * 25.05)

.goal
  h2, h4, .line
    max-width calc(var(--vw) * 66.93)

  h4
    width 100%

    .dot
      margin-left calc(var(--vw) * .52)
      margin-right calc(var(--vw) * .52)

.building
  .card
    top 50%
    left 80%
    transform translate(-50%, -50%)
    height calc(var(--vw) * 35.31)

    img
      max-height calc(var(--vw) * 18.23)
      margin-right auto
      width unset

.sector
  h2, h4, .line
    max-width calc(var(--vw) * 83.07)

  h4
    width 100%

    .dot
      margin-left calc(var(--vw) * 0.52)
      margin-right calc(var(--vw) * 0.52)

    &.special
      display flex
      flex-direction row
      justify-content space-between
      margin-top calc(var(--vw) * 3.13)

.train
  .card
    top 50%
    left 80%
    transform translate(-50%, -50%)
    height calc(var(--vw) * 30.36)

    img
      max-height calc(var(--vw) * 18.23)
      margin-right auto

.form
  h2, .line
    max-width calc(var(--vw) * 44.27)

  form
    max-width calc(var(--vw) * 44.27)
    width 100%
    display flex
    justify-content space-between

    .col
      flex: 0 0 calc(50% - (0.52 * var(--vw)))
      display flex
      flex-direction column

      &:first-child
        margin-right calc(var(--vw) * 1.04)

    .submit
      border 2px solid #FFFEFF
      padding calc(var(--vw) * 0.52) calc(var(--vw) * 1.56)
      font-family Arial, sans-serif
      font-size calc(var(--vw) * 0.94)
      font-style normal
      font-weight 700
      text-align center
      color #FFFEFF
      width calc(var(--vw) * 13.02)
      height calc(var(--vw) * 3.13)
      -webkit-appearance none
      cursor pointer
      border-radius calc(var(--vw) * 1.56)
      background transparent
      text-transform uppercase
      align-self flex-end
      overflow hidden
      mix-blend-mode difference
      position relative

      .bg
        width calc(100% - 2px)
        height calc(100% - 2px)
        position absolute
        top 1px
        left 1px
        background-color transparent
        border-radius calc(var(--vw) * 1.56)
        z-index -1
        mix-blend-mode none
        transition 0.3s background-color ease-in-out

      span
        position relative
        z-index 1
        mix-blend-mode difference
        display block

      .letter
        mix-blend-mode difference
        position absolute
        top 50%
        left 50%
        transform translateY(150%) translateX(-50%)

        img
          width 40px
          height 23px

      &:hover
        @media (min-width 1280px)
          .bg
            background-color white

.last-row
  background linear-gradient(360deg, #2C2C2C 72.07%, rgba(44, 44, 44, 0) 100%)
  min-height calc(var(--vw) * 45.52)
  position relative
  width 100%
  mix-blend-mode unset
  margin-top var(--height)

  .credentials
    position absolute
    bottom calc(var(--vw) * -5.52)
    left 0
    color white
    font-family Arial, sans-serif
    font-size calc(var(--vw) * 1)

  div
    position absolute
    bottom calc(var(--vw) * 11.46)
    left calc(var(--vw) * 12.76)

    h3
      font-family Arial, sans-serif
      font-size calc(var(--vw) * 2.65)
      font-style normal
      font-weight 400
      line-height calc(var(--vw) * 3.05)
      text-align left
      color white
      text-transform uppercase
      margin-bottom calc(var(--vw) * 5.21)

    h2
      font-family Arial, sans-serif
      font-size calc(var(--vw) * 3.75)
      font-style normal
      font-weight 700
      line-height calc(var(--vw) * 4.31)
      text-align left
      color white
      text-transform uppercase
      margin-bottom calc(var(--vw) * 0.52)

    a
      font-family Arial, sans-serif
      font-size calc(var(--vw) * 1.88)
      font-style normal
      font-weight 700
      line-height calc(var(--vw) * 2.6)
      text-align left
      color white
      text-transform uppercase
      position relative
      text-decoration none

      &:after
        content ''
        position absolute
        width 100%
        bottom -15%
        height 10%
        background-color white
        left 0
        transition 0.3s transform ease-in-out
        transform-origin left

      &:hover
        @media (min-width 1280px)
          &:after
            transform scaleX(0)

.menu
  position fixed
  top 0
  left 0
  background #fff
  mix-blend-mode unset
  width 100%
  height 100%
  z-index 4
  transform scaleY(0)
  opacity 0
  transition 0.5s transform ease-in-out 0.75s, 0.5s opacity ease-in-out 0.75s
  transform-origin top
  display none
  flex-direction column
  text-align center
  justify-content center
  align-items center

  .middle
    display flex
    flex-direction column

    a
      font-family Arial, sans-serif
      font-size calc(var(--vw) * 8.41)
      font-style normal
      font-weight 700
      line-height 1.4
      text-align center
      text-decoration none
      color black
      position relative
      overflow hidden

      span
        display block
        transform translateY(100%)
        transition 0.5s transform ease-in-out

      &:first-child
        margin-bottom calc(var(--vw) * 14.02)

  .bottom
    button
      font-family Arial, sans-serif
      font-size calc(var(--vw) * 4.21)
      font-style normal
      font-weight 700
      line-height 1.78
      text-align center
      width calc(var(--vw) * 12.15)
      height calc(var(--vw) * 12.15)
      border 2px solid black
      border-radius calc(var(--vw) * 7.01)
      cursor pointer
      -webkit-appearance none
      background-color transparent
      margin-top calc(var(--vw) * 58.88)
      transition 0.5s width ease-in-out 0.25s
      color black

      span
        opacity 0
        transition 0.25s opacity ease-in-out

  &.active
    transform scaleY(1)
    opacity 1
    transition 0.5s transform ease-in-out, 0.5s opacity ease-in-out

    .middle
      a
        span
          transform translateY(0)
          transition 0.5s transform ease-in-out 0.5s

    .bottom
      button
        width calc(var(--vw) * 57.24)
        transition 0.5s width ease-in-out 0.5s

        span
          opacity 1
          transition 0.5s opacity ease-in-out 1s

.burger
  g
    rect
      transition 0.5s transform ease-in-out
      transform-origin 50% 50%

  &.active
    g
      rect
        transform rotate(-90deg)

      &:nth-child(2), &:nth-child(3)
        rect
          opacity 0
</style>
<style>
@media screen and (min-aspect-ratio: 69/100) and (max-aspect-ratio: 1/1) {
  .text-block h2 {
    font-size: calc(var(--vw) * 4.3);
  }

  .text-block h4 {
    font-size: calc(var(--vw) * 2.64);
  }

  .text-block .line {
    margin: calc(var(--vw) * 2.93) 0;
  }

  .text-block h2.h2-ru {
    font-size: calc(var(--vw) * 4.88);
  }

  .text-block h4.h4-ru {
    font-size: calc(var(--vw) * 2.64);
  }

  .card {
    width: calc(var(--vw) * 46.88);
    padding: calc(var(--vw) * 2.93);
  }

  .card .border {
    width: calc(100% + (5.86 * var(--vw)));
    margin-left: calc(var(--vw) * -2.93);
    margin-top: calc(var(--vw) * -2.93);
    margin-bottom: calc(var(--vw) * 2.93);
  }

  .card .row:nth-child(2),
  .card .row:nth-child(3) {
    margin-bottom: calc(var(--vw) * 1.98);
  }

  .card .row:nth-child(4),
  .card .row:nth-child(5),
  .card .row:nth-child(6) {
    margin-bottom: calc(var(--vw) * 0.98);
  }

  .card .row:last-child {
    margin-bottom: 0;
  }

  .card .row h4 {
    font-size: calc(var(--vw) * 2.64);
  }

  .card .row h6 {
    font-size: calc(var(--vw) * 1.76);
  }

  .card .row .attr {
    font-size: calc(var(--vw) * 1.76);
  }

  br {
    display: none;
  }

  br.tablet {
    display: block;
  }

  .letter-desktop {
    display: inline;
  }

  .letter-tablet {
    display: none;
  }

  header {
    height: calc(var(--vw) * 5.86);
    padding-top: calc(var(--vw) * 2.15);
    width: calc(var(--vw) * 76.37);
    padding-left: calc(var(--vw) * 4.88);
  }

  header img {
    height: calc(var(--vw) * 1.66);
  }

  header a {
    font-size: calc(var(--vw) * 1.56);
  }

  header a .circle {
    width: calc(var(--vw) * 0.98);
    height: calc(var(--vw) * 0.98);
    margin-right: calc(var(--vw) * 0.98);
  }

  .top-row {
    padding-left: calc(var(--vw) * 4.88);
    padding-right: calc(var(--vw) * 4.88);
  }

  .top-row .overlay {
    height: calc(var(--vw) * 103.32);
  }

  .top-row .title {
    padding-top: calc(var(--vw) * 28.81);
  }

  .top-row .title h1.h1-ru {
    font-size: calc(var(--vw) * 4.88);
  }

  .arrow-top {
    top: calc(var(--vw) * 78.91);
  }

  .arrow-top svg {
    width: calc(var(--vw) * 5.86);
    height: calc(var(--vw) * 19.53);
  }

  .second-row h2 {
    margin-top: 50%;
  }

  .second-row h2,
  .second-row h4,
  .second-row .line {
    max-width: calc(var(--vw) * 74.8);
  }

  .second-row .line h4.h4-ru {
    min-width: calc(var(--vw) * 15.16);
  }

  .third-row .card {
    left: 29%;
    top: 70%;
    height: calc(var(--vw) * 29.3);
  }

  .how-row .line {
    margin-top: 50%;
  }

  .how-row h2,
  .how-row .line {
    max-width: calc(var(--vw) * 74.8);
    width: 100%;
  }

  .ru.how-row h2,
  .ru.how-row h4,
  .ru.how-row .line {
    max-width: calc(var(--vw) * 82.52);
  }

  .how-row h2 {
    font-size: calc(var(--vw) * 4.88);
  }

  .how-row .line h4 {
    margin-top: 1px;
    font-size: calc(var(--vw) * 3.52);
  }

  .motor .card {
    height: calc(var(--vw) * 39.5);
    left: 28%;
    top: 40%;
  }

  .goal h2 {
    margin-top: 50%;
  }

  .goal h2,
  .goal h4,
  .goal .line {
    max-width: calc(var(--vw) * 82.52);
  }

  .building .card {
    top: 75%;
    height: calc(var(--vw) * 54.39);
    left: 65%;
  }

  .building .card img {
    max-height: calc(var(--vw) * 31.05);
  }

  .sector h2,
  .sector h4,
  .sector .line {
    max-width: calc(var(--vw) * 82.52);
  }

  .sector h4.special {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .sector h4.special div {
    min-width: 30%;
  }

  .sector h4.special div:nth-child(2n) {
    min-width: 50%;
  }

  .ru.sector h4.special div {
    min-width: 100%;
    margin-top: calc(var(--vw) * 2.93);
  }

  .ru.sector h4.special div:first-child {
    margin-top: 0;
  }

  .train .card {
    top: 40%;
    left: 70%;
    height: calc(var(--vw) * 47.05);
  }

  .train .card img {
    max-height: calc(var(--vw) * 23.05);
    width: unset;
  }

  .form h2,
  .form .line,
  .form form {
    max-width: calc(var(--vw) * 59.57);
  }

  .form h2 {
    font-size: calc(var(--vw) * 4.88);
  }

  .form form .col .group input,
  .form form .col .group textarea,
  .form form .col .group label {
    font-size: calc(var(--vw) * 1.76);
    line-height: calc(var(--vw) * 3.13);
  }

  .form form .col .group textarea {
    height: calc(var(--vw) * 17.56);
  }

  .form form .col .group p,
  .form form .col .group .error {
    font-size: calc(var(--vw) * 1.17);
    margin-top: calc(var(--vw) * 1.27);
  }

  .form form .col .submit {
    width: calc(var(--vw) * 24.41);
    height: calc(var(--vw) * 5.86);
    border-radius: calc(var(--vw) * 2.93);
    font-size: calc(var(--vw) * 1.76);
  }

  .last-row {
    min-height: calc(var(--vw) * 53.52);
  }

  .last-row div {
    bottom: calc(var(--vw) * 19.24);
    left: calc(var(--vw) * 12.5);
  }

  .last-row div h3 {
    font-size: calc(var(--vw) * 2.64);
    line-height: calc(var(--vw) * 3.69);
    margin-bottom: calc(var(--vw) * 5.86);
  }

  .last-row div h2 {
    font-size: calc(var(--vw) * 4.88);
    line-height: calc(var(--vw) * 5.62);
    margin-bottom: calc(var(--vw) * 1.95);
  }

  .last-row div a {
    font-size: calc(var(--vw) * 2.64);
    line-height: calc(var(--vw) * 3.69);
  }

  .last-row .credentials {
    bottom: calc(var(--vw) * -5.52);
    font-size: calc(var(--vw) * 1.5);
  }
}

@media screen and (max-aspect-ratio: 69/100), (max-width: 375px) {
  .text-block h2 {
    font-size: calc(var(--vw) * 7.01);
  }

  .text-block h4 {
    font-size: calc(var(--vw) * 4.67);
  }

  .text-block .line {
    margin: calc(var(--vw) * 7.01) 0;
  }

  .text-block h2.h2-ru {
    font-size: calc(var(--vw) * 7.01);
  }

  .text-block h4.h4-ru {
    font-size: calc(var(--vw) * 4.67);
  }

  .card {
    width: calc(var(--vw) * 85.98);
    padding: calc(var(--vw) * 4.67);
  }

  .card .border {
    width: calc(100% + (9.34 * var(--vw)));
    margin-left: calc(var(--vw) * -4.67);
    margin-top: calc(var(--vw) * -4.67);
    margin-bottom: calc(var(--vw) * 4.67);
  }

  .card .row:nth-child(2),
  .card .row:nth-child(3) {
    margin-bottom: calc(var(--vw) * 2.34);
  }

  .card .row:nth-child(4),
  .card .row:nth-child(5),
  .card .row:nth-child(6) {
    margin-bottom: calc(var(--vw) * 2.34);
  }

  .card .row:last-child {
    margin-bottom: 0;
  }

  .card .row h4 {
    font-size: calc(var(--vw) * 6.31);
  }

  .card .row h6 {
    display: none;
  }

  .card .row .attr {
    font-size: calc(var(--vw) * 4.21);
  }

  br {
    display: none;
  }

  br.tablet {
    display: none;
  }

  br.mobile {
    display: block;
  }

  br.tablet-desktop {
    display: none;
  }

  .letter-mobile {
    display: none;
  }

  .letter-desktop {
    display: inline;
  }

  .letter-tablet {
    display: inline;
  }

  .letter-tablet-desktop {
    display: inline;
  }

  header {
    height: calc(var(--vw) * 11.69);
    padding-top: calc(var(--vw) * 2.34);
    width: 100%;
    padding-left: calc(var(--vw) * 7.01);
    padding-right: calc(var(--vw) * 7.01);
    justify-content: space-between;
  }

  header img {
    height: calc(var(--vw) * 3.97);
  }

  header a {
    display: none;
  }

  header svg {
    display: block;
    height: 100%;
    width: auto;
    mix-blend-mode: difference;
  }

  .top-row {
    padding-left: calc(var(--vw) * 7.01);
    padding-right: calc(var(--vw) * 7.01);
  }

  .top-row .overlay {
    height: calc(var(--vw) * 180.61);
  }

  .top-row .title {
    padding-top: calc(var(--vw) * 30.95);
  }

  .top-row .title h2,
  .top-row .title h1 {
    display: block;
    text-align: center;
    margin-right: 0;
  }

  .top-row .title h1 {
    font-size: calc(var(--vw) * 12.38);
    line-height: calc(var(--vw) * 14.24);
    margin-bottom: calc(var(--vw) * 2.34);
  }

  .top-row .title h1.h1-ru {
    font-size: calc(var(--vw) * 7.01);
    line-height: calc(var(--vw) * 8.06);
    text-align: left;
  }

  .top-row .title h2 {
    font-size: calc(var(--vw) * 5.84);
    line-height: calc(var(--vw) * 6.72);
  }

  .top-row .title h2 svg {
    margin-top: calc(var(--vw) * -2.1);
    margin-bottom: calc(var(--vw) * -3.5);
    width: calc(var(--vw) * 14.02);
    height: calc(var(--vw) * 14.02);
    mix-blend-mode: difference;
  }

  .top-row .title h2 div,
  .top-row .title h1 div {
    display: inline-block;
  }

  .top-row .title h2 div.letter-mobile,
  .top-row .title h1 div.letter-mobile {
    display: none;
  }

  .arrow-top {
    top: calc(var(--vw) * 107.1);
  }

  .arrow-top svg {
    width: calc(var(--vw) * 14.02);
    height: calc(var(--vw) * 46.73);
  }

  .second-row h2,
  .second-row h4,
  .second-row .line {
    max-width: calc(var(--vw) * 85.98);
  }

  .second-row .line h4.h4-ru {
    min-width: calc(var(--vw) * 27);
  }

  .second-row h4.special-ru {
    margin-top: calc(var(--vw) * 7.01);
  }

  .third-row .card {
    left: 50%;
    top: unset;
    bottom: 2%;
    height: calc(var(--vw) * 56.07);
  }

  .how-row h2,
  .how-row .line {
    max-width: calc(var(--vw) * 85.98);
  }

  .how-row h2 {
    font-size: calc(var(--vw) * 7.01);
  }

  .how-row .line h4 {
    margin-top: 1px;
    font-size: calc(var(--vw) * 8.41);
  }

  .how-row.ru h2,
  .how-row.ru h4,
  .how-row.ru .line {
    max-width: calc(var(--vw) * 85.98);
  }

  .motor .card {
    height: calc(var(--vw) * 81.31);
    left: 50%;
    top: 40%;
  }

  .goal h2,
  .goal h4,
  .goal .line {
    max-width: calc(var(--vw) * 85.98);
  }

  .building .card {
    top: unset;
    bottom: -15%;
    height: calc(var(--vw) * 112.5);
    left: 50%;
  }

  .building .card img {
    max-height: calc(var(--vw) * 57.94);
  }

  .sector h2,
  .sector h4,
  .sector .line {
    max-width: calc(var(--vw) * 85.98);
  }

  .sector h4.special {
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: calc(var(--vw) * 7.01);
  }

  .sector h4.special div {
    min-width: 100%;
  }

  .sector h4.special div:nth-child(2n) {
    min-width: 100%;
  }

  .train .card {
    top: unset;
    bottom: -10%;
    left: 50%;
    height: calc(var(--vw) * 95.88);
  }

  .train .card img {
    max-height: calc(var(--vw) * 48.83);
    width: unset;
  }

  .form h2,
  .form .line,
  .form form {
    max-width: calc(var(--vw) * 85.98);
  }

  .form form {
    flex-direction: column;
  }

  .form h2 {
    font-size: calc(var(--vw) * 7.01);
  }

  .form form .col:first-child {
    margin-right: 0;
  }

  .form form .col .group {
    margin-bottom: calc(var(--vw) * 7.94);
  }

  .form form .col .group input,
  .form form .col .group textarea,
  .form form .col .group label {
    font-size: calc(var(--vw) * 4.21);
    line-height: calc(var(--vw) * 7.48);
  }

  .form form .col .group label {
    left: calc(var(--vw) * 3.94);
  }

  .form form .col .group textarea {
    height: calc(var(--vw) * 15.58);
  }

  .form form .col .group p,
  .form form .col .group .error {
    font-size: calc(var(--vw) * 2.8);
    bottom: calc(var(--vw) * -3.04);
  }

  .form form .col .submit {
    width: calc(var(--vw) * 58.41);
    height: calc(var(--vw) * 14.02);
    border-radius: calc(var(--vw) * 7.01);
    font-size: calc(var(--vw) * 4.21);
  }

  .form form .col .group input:focus ~ label,
  .form form .col .group input:valid ~ label {
    top: calc(var(--vw) * -5.56);
  }

  .form form .col .group textarea:focus ~ label,
  .form form .col .group textarea:valid ~ label {
    top: calc(var(--vw) * -5.56);
  }

  .last-row {
    min-height: calc(var(--vw) * 128.04);
  }

  .last-row div {
    bottom: calc(var(--vw) * 36.45);
    left: calc(var(--vw) * 7.01);
  }

  .last-row div h3 {
    font-size: calc(var(--vw) * 6.31);
    line-height: calc(var(--vw) * 8.83);
    margin-bottom: calc(var(--vw) * 7.01);
  }

  .last-row div h2 {
    font-size: calc(var(--vw) * 11.68);
    line-height: calc(var(--vw) * 13.43);
    margin-bottom: calc(var(--vw) * 7.01);
  }

  .last-row div a {
    font-size: calc(var(--vw) * 3.97);
    line-height: calc(var(--vw) * 5.56);
  }

  .last-row .credentials {
    bottom: calc(var(--vw) * -9.52);
    font-size: calc(var(--vw) * 2.5);
  }

  .menu {
    display: flex;
  }
}

@media (max-height: 500px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  header img {
    height: calc(var(--vw) * 1.93);
  }

  header a {
    display: none;
  }

  .ru.top-row .title {
    padding-top: calc(var(--vw) * 8.52);
  }

  .arrow-top {
    top: calc(var(--vw) * 27.65);
  }

  .arrow-top svg {
    height: calc(var(--vw) * 19.34);
    width: calc(var(--vw) * 5.8);
  }

  .card {
    width: calc(var(--vw) * 34.69);
  }

  .card .row:nth-child(2),
  .card .row:nth-child(3) {
    margin-bottom: calc(var(--vw) * 1.13);
  }

  .card .row:nth-child(4),
  .card .row:nth-child(5),
  .card .row:nth-child(6) {
    margin-bottom: 0;
  }

  .card .row h4 {
    font-size: calc(var(--vw) * 2.72);
  }

  .card .row h6 {
    display: none;
  }

  .card .row .attr {
    font-size: calc(var(--vw) * 1.59);
  }

  .third-row .card {
    height: calc(var(--vw) * 21.43);
  }

  .motor .card {
    height: calc(var(--vw) * 30);
  }

  .train .card {
    height: calc(var(--vw) * 36);
  }

  .form {
    left: 50%;
    transform: translateX(-50%);
  }

  .form h2,
  .form .line,
  .form form {
    max-width: calc(var(--vw) * 60.27);
  }

  .form form .submit {
    width: calc(var(--vw) * 14.02);
  }

  .form form .col .group textarea {
    height: calc(var(--vw) * 13.3);
  }

  header {
    width: 100%;
    padding-right: calc(var(--vw) * 5.21);
    justify-content: space-between;
  }

  header svg {
    display: block;
  }

  .menu {
    display: flex;
    flex-direction: row;
  }

  .menu .bottom button {
    margin-top: 0;
  }

  .menu .middle {
    margin-right: 30px;
  }

  .menu .middle a:first-child {
    margin-bottom: 20px;
  }

  .menu .middle a {
    font-size: calc(var(--vw) * 6.41);
  }

  .menu .bottom button {
    font-size: calc(var(--vw) * 3.21);
    height: calc(var(--vw) * 9.15);
    width: calc(var(--vw) * 9.15);
  }

  .menu.active .bottom button {
    width: calc(var(--vw) * 40.24);
  }

  .last-row .credentials {
    bottom: calc(var(--vw) * -5.52);
    font-size: calc(var(--vw) * 1.5);
  }
}

@media (max-width: 375px) and (max-height: 600px) {
  .arrow-top {
    top: calc(var(--vw) * 95.1);
  }

  .building .card {
    top: 55%;
  }

  .form form .col .group {
    margin-bottom: calc(var(--vw) * 4.94);
  }

  .text-block .line {
    margin: calc(var(--vw) * 4.01) 0;
  }

  .second-row.ru .line,
  .second-row.ru h4:last-child {
    display: none;
  }
}
</style>
